import moment from "moment";
import { AppConfig } from "../services/app.config";

export class DataUtilsCore {
    static iconFileList = [
        { type: "xlsx", icon: "fa fa-file-excel text-success" },
        { type: "xls", icon: "fa fa-file-excel text-success" },
        { type: "xlm", icon: "fa fa-file-excel text-success" },
        { type: "xltx", icon: "fa fa-file-excel text-success" },
        { type: "xlt", icon: "fa fa-file-excel text-success" },
        { type: "pdf", icon: "fa fa-file-pdf text-danger" },
        { type: "jpg", icon: "fa fa-file-image text-warning" },
        { type: "jpeg", icon: "fa fa-file-image text-warning" },
        { type: "png", icon: "fa fa-file-image text-warning" },
        { type: "gif", icon: "fa fa-file-image text-warning" },
        { type: "jpe", icon: "fa fa-file-image text-warning" },
        { type: "jfif", icon: "fa fa-file-image text-warning" },
        { type: "bmp", icon: "fa fa-file-image text-warning" },
        { type: "doc", icon: "fa fa-file-word text-primary" },
        { type: "docx", icon: "fa fa-file-word text-primary" },
        { type: "ppt", icon: "fa fa-file-powerpoint text-danger" },
        { type: "zip", icon: "fa fa-file-archive text-muted" },
        { type: "html", icon: "fa fa-file-code text-info" },
        { type: "txt", icon: "fa fa-file-text text-info" },
        { type: "mov", icon: "fa fa-file-movie-o text-warning" },
        { type: "mp3", icon: "fa fa-file-audio text-warning" }
    ];
    static getToVisString(dataColumn, data) {
        let result = "";
        let colText1 = dataColumn.filter(x => x.VisRef == 2);
        if (colText1.length > 0) {
            let text = data[colText1[0]['Name']]["r"];
            if(typeof text == 'string') {
                text = text.replace(/<[^>]*>?/g, ',');
            }
            result = text;
        }
        return result
    }
    static formatDateTime(value, format, inputFormat?: string) {
        if(inputFormat){
            return moment(value, inputFormat).format(format);
        }
        return moment(value).format(format);
    }
    static formatCharToDateTime(value, format) {
        return moment(value, format).toDate();
    }
    static getFilenameAndExtension(pathfilename) {
        var filenameextension = pathfilename.replace(/^.*[\\\/]/, '');
        var filename = filenameextension.substring(0, filenameextension.lastIndexOf('.'));
        var ext = filenameextension.split('.').pop();
        return [filename, ext, filenameextension];
    }
    static getIconFileExtension(ext) {
        ext = ext.toLocaleLowerCase();
        let obj = this.iconFileList.filter(row => {
            if (row.type === ext) {
                return true;
            }
        });
        if (obj.length > 0) {
            let icon = obj[0].icon;
            return icon;
        } else {
            return "fa fa-link text-success";
        }
    }
    static isImagePath(path) {
        // Regular expression to match common image file extensions
        var imageExtensions = /\.(jpg|jpeg|png|gif)$/i;

        // Test if the path ends with an image file extension
        return imageExtensions.test(path);
    }
    static formatBytesFile(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes'
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    static setIconFile(File_Type) {
        if (File_Type == "application/msword" || File_Type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            return "fa-regular fa-file-word";
        } else if (File_Type == "application/vnd.ms-excel" || File_Type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            return "fa-regular fa-file-excel";
        } else if (File_Type == "application/pdf") {
            return "fa-regular fa-file-pdf";
        } else if (File_Type == "application/vnd.ms-powerpoint" || File_Type == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
            return "fa-regular fa-file-powerpoint";
        } else if (File_Type.startsWith('image')) {
            return "fa-solid fa-image";
        }
        return "fa-regular fa-file"
    }
    /**
     * Convert a template string into HTML DOM Nodes
     * Tuong.TT - 2024-05-16
     * @param str 
     * @returns {Node} HTMLDocument
     */
    static stringToHTML(str: string): HTMLDocument {
        let parser = new DOMParser();
        let doc = parser.parseFromString(str, 'text/html');
        return doc;
    }
    static getQueryStrings(data) {
        var assoc = {};
        var decode = function (s) {
            return decodeURIComponent(s.replace(/\+/g, " "));
        };
        var queryString = data.replace("?", "&");
        var keyValues = queryString.split('&');

        for (var i in keyValues) {
            var key = keyValues[i].split('=');
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]).replace("KY_TU_BANG", "=");
            }
        }

        return assoc;
    }
    static renderUrlImage(value) {
        if (value == null || value == "") {
            return AppConfig.config.application.appNoImage;
        }
        if (value == "/Content/GPG_CMS/assets/layouts/layout3/img/logo-gpg.png") {
            return AppConfig.config.application.appNoImage;
        }
        if (value.startsWith("http")) {
            return value;
        }
        return AppConfig.config.apis.appImageUrl + value;
    }
    static customformatVND(number:any) {
        number = parseFloat(number); // Chuyển chuỗi thành số thực
        if (!isNaN(number) && isFinite(number)) {
            // Định dạng phần thập phân (2 chữ số thập phân)
            var parts = number.toString().split('.');
            // Thêm dấu phân cách hàng nghìn
            var integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            var decimalPart = parts[1];
            var end = (decimalPart == undefined || parseFloat(decimalPart) == 0) ? "" : '.' + decimalPart
            return integerPart + end;
        } else {
            // Nếu không hợp lệ, trả về -1
            return "";
        }
    }
    static ISO6346Check(con) {
        var con = con.replace(' ', '');
        if (!con || con == "" || con.length != 11) { return false; }
        con = con.toUpperCase();
        var re = /^[A-Z]{4}\d{7}/;
        if (re.test(con)) {
            var sum = 0;
            for (var i = 0; i < 10; i++) {
                var n = con.substr(i, 1);
                if (i < 4) {
                    n = "0123456789A?BCDEFGHIJK?LMNOPQRSTU?VWXYZ".indexOf(con.substr(i, 1));
                }
                n *= Math.pow(2, i); //2 mũ i
                sum += n;
            }
            if (con.substr(0, 4) == "HLCU") { sum -= 2; }
            sum %= 11;
            sum %= 10; //Chia cho 10 lấy phần dư
            return sum == con.substr(10);
        }
        else { return false; }
    }
}
